module.exports = __webpack_public_path__ + "img/img2_2.56b120e4.jpeg";